export default "/img/ZM.31fc9d1a3da80a300bf2c162b473d626.png";